/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function ExporterProfile() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const {
		exporterProfileFirstQuestion = "NO",
		exporterProfileSecondQuestion = "NO",
		exporterProfileThirdQuestion = "NO",
		exporterProfileComment,
	} = countryBrandApplication;

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const exporterProfileFirstQuestion = formElement.elements.firstQuestion.value;
			const exporterProfileSecondQuestion = formElement.elements.secondQuestion.value;
			const exporterProfileThirdQuestion = formElement.elements.thirdQuestion.value;
			const exporterProfileComment = formElement.elements.comment.value;

			update({
				data: {
					exporterProfileFirstQuestion,
					exporterProfileSecondQuestion,
					exporterProfileThirdQuestion,
					exporterProfileComment,
				},
				nextStep: currentStep + 1,
			});
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	return (
		<div className="step-page" id="step-8">
			<section>
				<h3>8 - Perfil Exportador</h3>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Si</th>
							<th>No</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>¿Exporta actualmente?</td>
							<td>
								<input
									type="radio"
									value="SI"
									name="firstQuestion"
									defaultChecked={exporterProfileFirstQuestion === "SI"}
								/>
							</td>
							<td>
								<input
									type="radio"
									value="NO"
									name="firstQuestion"
									defaultChecked={exporterProfileFirstQuestion === "NO"}
								/>
							</td>
						</tr>
						<tr>
							<td>¿Tiene posibilidades de internacionalización / capacidad exportadora?</td>
							<td>
								<input
									type="radio"
									value="SI"
									name="secondQuestion"
									defaultChecked={exporterProfileSecondQuestion === "SI"}
								/>
							</td>
							<td>
								<input
									type="radio"
									value="NO"
									name="secondQuestion"
									defaultChecked={exporterProfileSecondQuestion === "NO"}
								/>
							</td>
						</tr>
						<tr>
							<td>¿Brinda servicios a extranjeros en el territorio uruguayo?</td>
							<td>
								<input
									type="radio"
									value="SI"
									name="thirdQuestion"
									defaultChecked={exporterProfileThirdQuestion === "SI"}
								/>
							</td>
							<td>
								<input
									type="radio"
									value="NO"
									name="thirdQuestion"
									defaultChecked={exporterProfileThirdQuestion === "NO"}
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<label htmlFor="comment">
					Comentarios / Observaciones:
					<textarea name="comment" defaultValue={exporterProfileComment} />
				</label>
			</section>
		</div>
	);
}

export { ExporterProfile };
